/**
 * The cross-model budget version register. `/budget/versions/:id` (the version
 * document) stays in the module's root route table; this file adds only the list.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_PERMISSIONS } from '@/modules/budget/permissions'

export const BUDGET_VERSION_LIST_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/versions',
    name: 'budget-versions',
    component: () => import('@/modules/budget/versions/VersionsListView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetVersions',
      permission: BUDGET_PERMISSIONS.versionRead,
    },
  },
]

export function versionsRoute(): string {
  return '/budget/versions'
}
